// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__XhTq8","content":"modal_content__wZVbb","fullwidth":"modal_fullwidth__akEaW"};